var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 87,
    viewBox: "0 0 119 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8863 86.3229H29.7776C21.6521 86.3229 14.7088 83.4954 8.94777 77.8405C3.1867 72.1856 0.307955 65.2741 0.311527 57.1059C0.311527 50.1046 2.40987 43.8663 6.60656 38.3909C10.8032 32.9156 16.2947 29.4149 23.0808 27.889C25.3131 19.631 29.7776 12.9439 36.4745 7.82758C43.1713 2.71124 50.7611 0.153076 59.2437 0.153076C69.6908 0.153076 78.5539 3.8117 85.8329 11.129C93.1119 18.4462 96.7496 27.354 96.7461 37.8524C102.907 38.5704 108.02 41.2417 112.085 45.8662C116.149 50.4906 118.18 55.8978 118.176 62.0876C118.176 68.8196 115.831 74.5427 111.142 79.257C106.452 83.9712 100.761 86.3265 94.0673 86.3229H64.6012V47.8158L73.1732 56.1634L80.6736 48.6236L59.2437 27.0811L37.8138 48.6236L45.3143 56.1634L53.8863 47.8158V86.3229Z",
    fill: "#A0A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.8807eaa3752a59844207d39b2dedaf60.svg";
export { ForwardRef as ReactComponent };